import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { FormlyModule } from '@ngx-formly/core';
import { GoalModule } from './goal/goal.module';
import { UserModule } from './user/user.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ResumeModule } from './resume/resume.module';
import { AppRoutingModule } from './app-routing.module';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { ResourceModule } from './resource/resource.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { AssessmentModule } from './assessment/assessment.module';
import { GtapMaterialsModule } from './gtap-materials/gtap-materials.module';
import { AuthenticationModule } from './authentication/authentication.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FirstWrapperComponent } from './gtap-materials/frist-wrapper.component';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { reducers, metaReducers } from './reducers';
import { NgxPrinterModule } from 'ngx-printer';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    GoalModule,
    UserModule,
    ResumeModule,
    ResourceModule,
    DashboardModule,
    AssessmentModule,
    GtapMaterialsModule,
    AuthenticationModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    NgxPrinterModule.forRoot({printOpenWindow: true}),
    FormlyModule.forRoot({
      extras: { lazyRender: true },
      wrappers: [{ name: 'firstWrapper', component: FirstWrapperComponent }],
    }),
    FormlyMaterialModule,
    StoreModule.forRoot(reducers, { metaReducers }),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    }),
    EffectsModule.forRoot([]),
    StoreRouterConnectingModule.forRoot(),
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
